var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHead = function SvgHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 15.9987H1.33333C0.597333 15.9987 0 15.4027 0 14.6654C0 13.928 0.597333 13.332 1.33333 13.332H30.6667C31.4027 13.332 32 13.928 32 14.6654C32 15.4027 31.4027 15.9987 30.6667 15.9987Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0H4C1.79467 0 0 1.79467 0 4V6.66667C0 7.404 0.597333 8 1.33333 8C2.06933 8 2.66667 7.404 2.66667 6.66667V4C2.66667 3.264 3.26533 2.66667 4 2.66667H6.66667C7.40267 2.66667 8 2.07067 8 1.33333C8 0.596 7.40267 0 6.66667 0Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 29.3333H4C3.26533 29.3333 2.66667 28.736 2.66667 28V25.3333C2.66667 24.596 2.06933 24 1.33333 24C0.597333 24 0 24.596 0 25.3333V28C0 30.2053 1.79467 32 4 32H6.66667C7.40267 32 8 31.404 8 30.6667C8 29.9293 7.40267 29.3333 6.66667 29.3333Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H25.3333C24.5973 0 24 0.596 24 1.33333C24 2.07067 24.5973 2.66667 25.3333 2.66667H28C28.7347 2.66667 29.3333 3.264 29.3333 4V6.66667C29.3333 7.404 29.9307 8 30.6667 8C31.4027 8 32 7.404 32 6.66667V4C32 1.79467 30.2053 0 28 0Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 24C29.9307 24 29.3333 24.596 29.3333 25.3333V28C29.3333 28.736 28.7347 29.3333 28 29.3333H25.3333C24.5973 29.3333 24 29.9293 24 30.6667C24 31.404 24.5973 32 25.3333 32H28C30.2053 32 32 30.2053 32 28V25.3333C32 24.596 31.4027 24 30.6667 24Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6001 14C26.6281 13.7107 26.6668 13.424 26.6668 13.1307C26.6668 8.096 22.5321 4 17.4494 4C12.3668 4 8.23343 8.096 8.23343 13.1347C8.23343 13.4333 8.16543 13.7213 8.06543 14H26.6001Z",
    fill: "#94C03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61434 18L5.56367 18.08C5.41301 18.3187 5.33301 18.592 5.33301 18.8693C5.33301 19.684 5.99834 20.3467 6.81567 20.3467H8.23301V22.6947C8.23301 24.0373 9.33301 25.1293 10.6837 25.1293C10.9503 25.1293 11.2037 25.0893 11.397 25.02L13.0663 24.52V27C13.0663 27.552 13.5143 28 14.0663 28H22.7663C23.3183 28 23.7663 27.552 23.7663 27V22.1933C23.7663 20.824 24.189 19.504 24.9877 18.3813C25.0743 18.26 25.1357 18.1267 25.2157 18.0013H5.61434V18Z",
    fill: "#94C03D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/head.84209136.svg";
export { ForwardRef as ReactComponent };